<template>
  <div>
    <div class="intro-y flex items-center mt-8">
      <h2 class="text-lg font-medium mr-auto">Quizzes</h2>
    </div>
    <Table class="mt-5"></Table>
  </div>
</template>

<script>
import Table from "../../components/Core/UTableQuiz";
export default {
  components: {
    Table
  },
  data() {
    return {
      model: {
        quiz_title: "",
        quiz_subject: "",
        time_required: "",
        status: "",
      },
      isModal: true
    };
  }
};
</script>
